import { ReactNode, useCallback, useState } from 'react';
import DeleteModal from '../components/DeleteModal/index.js';

interface UseDeleteModalProps {
  loading: boolean;
  onRemove: () => void;
  label: string;
  text: string;
}

interface UseDeleteModal {
  openModal: () => void;
  DeleteModalComponent: ReactNode;
}

const useDeleteModal = ({
  label,
  loading,
  onRemove,
  text,
}: UseDeleteModalProps): UseDeleteModal => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = (): void => {
    setIsOpen(false);
  };

  const openModal = useCallback((): void => setIsOpen(true), []);

  const onDelete = (): void => {
    onRemove();
    onClose();
  };

  const DeleteModalComponent = (
    <DeleteModal
      onClose={onClose}
      loading={loading}
      label={label}
      text={text}
      isOpen={isOpen}
      onDelete={onDelete}
    />
  );

  return {
    openModal,
    DeleteModalComponent,
  };
};

export default useDeleteModal;
